export default __webpack_public_path__ + "static/media/github.118414f5.svg";